import React, { useState } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const ORIGINAL_SAMPLE_HEADERS = [
  'Artikelname',
  'Artikelart',
  'Arbeitshöhe',
  'Maschinentyp',
  'Produktgruppe',
  'Motorisierung',
  'Hersteller',
  'Herstellertyp',
  'Gesamtgewicht',
  'Baujahr',
  'Seriennummer',
  'Beschreibung',
  'interne Notiz',
  'Korbarm',
  'Kalender',
  'Liftworker ID',
  'Liftworker Typ',
  'Buchungskonto',
  'Verknüpfte Artikel',
  'nächste UVV Prüfung',
  'Farbcode',
];

const ImportItemForm = () => {
  const [file, setFile] = useState(null);
  const [mode, setMode] = useState('liftworker-update');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
    setSuccess('');
  };

  const handleImport = async () => {
    if (!file) {
      setError('Bitte wähle eine CSV-Datei aus.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('mode', mode);

    try {
      const response = await api.post('/items/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (mode === 'original-create') {
        const { created = 0, updated = 0, skipped = 0, warnings = [] } = response.data;
        const warningText = warnings.length
          ? ` Hinweise: ${warnings.slice(0, 5).join(' | ')}${warnings.length > 5 ? ' | ...' : ''}`
          : '';

        setSuccess(
          `Import erfolgreich: ${created} neu, ${updated} aktualisiert, ${skipped} übersprungen.${warningText}`
        );
      } else {
        setSuccess(`Import erfolgreich: ${response.data.updated} Datensätze verarbeitet.`);
      }
    } catch (err) {
      console.error('Import-Fehler:', err);
      setError(err.response?.data?.error || 'Import fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  const isOriginalImport = mode === 'original-create';

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '760px' }}>
        <Helmet>
          <title>Artikel per CSV importieren</title>
          <meta name="description" content="CSV-Import für Artikel" />
        </Helmet>

        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>CSV-Import für Artikel</h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: '12px',
            marginBottom: '20px',
          }}
        >
          <select
            value={mode}
            onChange={(e) => {
              setMode(e.target.value);
              setError('');
              setSuccess('');
            }}
            style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
          >
            <option value="liftworker-update">Bestehende Liftworker-Artikel aktualisieren</option>
            <option value="original-create">Originalartikel aus anderem System importieren</option>
          </select>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '3fr 1fr',
              gap: '10px',
              alignItems: 'center',
            }}
          >
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '4px' }}
            />
            <button
              onClick={handleImport}
              disabled={loading}
              style={{
                padding: '10px 12px',
                background: loading ? '#6c757d' : '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer',
              }}
            >
              {loading ? 'Import läuft…' : 'Import starten'}
            </button>
          </div>
        </div>

        {isOriginalImport && (
          <div
            style={{
              marginBottom: '20px',
              padding: '14px',
              border: '1px solid #d9d9d9',
              borderRadius: '6px',
              background: '#f8f9fa',
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: '8px' }}>Empfohlene CSV-Spalten</div>
            <div style={{ fontSize: '14px', color: '#555', marginBottom: '10px' }}>
              Trenner: <strong>Semikolon</strong>. Verknüpfte Artikel können über
              Artikel-ID, `lw:LiftworkerID`, `sn:Seriennummer` oder exakten Artikelnamen
              referenziert werden. Mehrere Verknüpfungen bitte mit `|` trennen.
            </div>
            <pre
              style={{
                margin: 0,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                fontSize: '13px',
              }}
            >
              {ORIGINAL_SAMPLE_HEADERS.join(';')}
            </pre>
          </div>
        )}

        {!isOriginalImport && (
          <div
            style={{
              marginBottom: '20px',
              padding: '14px',
              border: '1px solid #d9d9d9',
              borderRadius: '6px',
              background: '#f8f9fa',
              fontSize: '14px',
              color: '#555',
            }}
          >
            Dieser Modus aktualisiert vorhandene Artikel anhand der `liftworkerId`. Die CSV
            verwendet weiterhin die bisherigen internen Feldnamen.
          </div>
        )}

        {error && <div style={{ color: '#dc3545', marginBottom: '10px' }}>{error}</div>}
        {success && <div style={{ color: '#28a745', marginBottom: '10px' }}>{success}</div>}
      </div>
    </div>
  );
};

export default ImportItemForm;
